module.exports = __webpack_public_path__ + "img/essilor.1117f0a8.jpg";